import axios from "axios";

const APIs = axios.create({
    //baseURL: "https://api.eagleobc.com/api/app/",
    //baseURL: "http://localhost:7034/app/"
    baseURL: "https://eagleobcapi.csnsindia.com/api/app/",
});

// Middleware-like: Request interceptor
APIs.interceptors.request.use(
  (config) => {
    // Add token if exists
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    if (userData?.token) {
      config.headers.Authorization = `Bearer ${userData.token}`;
    }
    console.log("Request sent to:", config.url);
    return config;
  },
  (error) => Promise.reject(error)
);

// Middleware-like: Response interceptor
APIs.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error.response?.data?.message);
    return Promise.reject(error);
  }
);

export default APIs;
